import React, { Suspense, lazy } from "react";
import { Redirect, Switch, Route } from "react-router-dom";
import { LayoutSplashScreen, ContentRoute } from "../_metronic/layout";
import { DashboardPage } from "./pages/DashboardPage";
import {
  canReadMarketing,
  getDefaultBackofficePath,
  isFullAdmin,
} from "./modules/Auth/access";

const Users = lazy(() =>
  import("./modules/Users/pages/UsersModule")
);

const Hardware = lazy(() =>
  import("./modules/Hardware/pages/HardwareModule")
);

const Company = lazy(() =>
  import("./modules/Company/pages/CompanyModule")
);

const Marketing = lazy(() =>
  import("./modules/Marketing/pages/MarketingModule")
);

const Permissions = lazy(() =>
  import("./modules/Permissions/pages/PermissionsModule")
);

export default function BasePage({ user }) {
  const fullAdmin = isFullAdmin(user);
  const marketingEnabled = canReadMarketing(user);
  const defaultPath = getDefaultBackofficePath(user);

  return (
    <Suspense fallback={<LayoutSplashScreen />}>
      <Switch>
        {
          /* Redirect from root URL to /dashboard. */
          <Redirect exact from="/" to={defaultPath} />
        }
        {marketingEnabled && <Route path="/marketing" component={Marketing} />}
        {fullAdmin && <ContentRoute path="/dashboard" component={DashboardPage} />}
        {fullAdmin && <Route path="/permissions" component={Permissions} />}
        {fullAdmin && <Route path="/users" component={Users} />}
        {fullAdmin && <Route path={["/hardware", "/commands"]} component={Hardware} />}
        {fullAdmin && <Redirect exact from="/company" to="/users" />}
        {fullAdmin && <Route path={["/company/:id/plan", "/company/:id/domes"]} component={Company} />}
        <Redirect to={defaultPath} />
      </Switch>
    </Suspense>
  );
}
